<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 15/11/2021
  -->

<template>
<div>

	<FormSelectRow
		ref="formSelectRow"
		v-model="valueData"
		labelKey="name"
		value-key="id"
		filterable
		:readonly="readonly"
		:allow-create="canCreateComputed"
		:showClickToCreatePrompt="true"
		placeholder="Type client's name"
		:options-pager-provider="getClientsPager"
		@createNewItem="createNewItem"
		@change="onClientPickerValueChanged">

		<template #empty-view>
			<div class="text-center text-muted my-4">
				<div class="mb-2">No Client found.</div>
				<small v-if="canCreateComputed">Click the name above to create a new client.</small>
			</div>

		</template>

	</FormSelectRow>
</div>
</template>

<script>

import FormSelectRow from "@/core/components/Form/FormSelectRow.vue";
import BaseVModelView from "@/core/components/BaseVModelView.vue";
import SearchKeywordsFilter from "@/core/js/backend/filters/SearchKeywordsFilter";
import ClientProfile from "@shared/Profile/ClientProfile";

export default {
	name: "ClientPickerView",
	components: {FormSelectRow},
	extends: BaseVModelView,

	props: {
		readonly: Boolean,
		canCreate: {Boolean, default: true}
	},

	data() {
		return {
			filter: new SearchKeywordsFilter(),
		}
	},

	methods: {

		focus(){
			this.$refs.formSelectRow.focus()
		},

		async getClientsPager(query = "") {
			console.log("ClientPickerView.getClientsPager: ", query)
			this.filter.reset(query)
			this.filter.where("isEnabled", "==", true)
			return this.$dataManager.getClientProfileListPager(this.filter, 5)
		},

		onClientPickerValueChanged(value){
			// if(typeof value === "string"){
			// 	let clientProfile = new ClientProfile(value)
			// 	clientProfile._notSaved = true
			// 	this.valueData = clientProfile
			// }
			this.notifyValueChanged()
		},
		createNewItem(query){
			let clientProfile = new ClientProfile(query)
			clientProfile._notSaved = true
			return clientProfile
		}

	},

	computed: {
		canCreateComputed() {
			if(this.canCreate !== undefined){
				return this.canCreate
			}
			return this.isOwner
		}
	},

}
</script>

<style lang="scss">

</style>
